'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverSideValidation = exports.validateForm = exports.validateField = exports.validateFormAction = exports.validatingFieldAction = exports.validateFieldAction = undefined;
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _lodash = require('lodash');
var _arrayToIso = require('@marmalade/date/lib/array-to-iso');
var _arrayToIso2 = _interopRequireDefault(_arrayToIso);
var _constants = require('../constants');
var _formInfo = require('../selectors/form-info');
var _employmentLookup = require('../selectors/employment-lookup');
var _addressLookup = require('../selectors/address-lookup');
var _vehicleLookup = require('../selectors/vehicle-lookup');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
var ua = window.navigator.userAgent;
var IE = !!~ua.indexOf('MSIE ') || !!~ua.indexOf('Trident/');
var validateFieldAction = exports.validateFieldAction = function validateFieldAction(formId, name, error) {
  return {
    type: _constants.actionTypes.VALIDATE_FIELD,
    formId: formId,
    name: name,
    error: error
  };
};
var validatingFieldAction = exports.validatingFieldAction = function validatingFieldAction(formId, name) {
  return {
    type: _constants.actionTypes.VALIDATING_FIELD,
    formId: formId,
    name: name
  };
};
var validateFormAction = exports.validateFormAction = function validateFormAction(formId, errors) {
  return {
    type: _constants.actionTypes.VALIDATE_FORM,
    formId: formId,
    errors: errors
  };
};

// For validating single fields
// The async thunk allows multiple tests to be fired in order
var validateField = exports.validateField = function validateField(formId, name, validate) {
  return function () {
    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, values, validator, error, _error;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(validate !== undefined)) {
                _context.next = 16;
                break;
              }
              state = getState();
              values = (0, _formInfo.getValues)(state, formId, name);
              validator = validate(values[name], Object.assign({}, values, {
                __extra: {
                  employmentLookup: (0, _employmentLookup.employmentLookup)(state, formId),
                  addressLookup: (0, _addressLookup.addressLookup)(state, formId),
                  vehicleLookup: (0, _vehicleLookup.vehicleLookup)(state, formId)
                }
              }));
              if (!(typeof validator === 'function')) {
                _context.next = 14;
                break;
              }
              error = '';
              if (IE) {
                _context.next = 11;
                break;
              }
              dispatch(validatingFieldAction(formId, name));
              _context.next = 10;
              return validator();
            case 10:
              error = _context.sent;
            case 11:
              dispatch(validateFieldAction(formId, name, error));
              _context.next = 16;
              break;
            case 14:
              _error = validator;
              dispatch(validateFieldAction(formId, name, _error));
            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var validateForm = exports.validateForm = function validateForm(formId, formValidator) {
  return function () {
    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var values, errors, async, asyncNames, state, name, fieldValidator;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              values = (0, _formInfo.getValues)(getState(), formId);
              errors = {}; // for dispatching to store at the end

              async = []; // for collecting promises (stored in functions) to fire together

              asyncNames = []; // for mapping async validators to field names

              state = getState();
              for (name in formValidator) {
                // execute all the validators,
                // the async ones return functions,
                // the sync ones return strings (error messages)
                fieldValidator = formValidator[name](values[name], Object.assign({}, values, {
                  __extra: {
                    employmentLookup: (0, _employmentLookup.employmentLookup)(state, formId),
                    addressLookup: (0, _addressLookup.addressLookup)(state, formId),
                    vehicleLookup: (0, _vehicleLookup.vehicleLookup)(state, formId)
                  }
                }));
                if (typeof fieldValidator === 'function') {
                  async.push(fieldValidator);
                  asyncNames.push(name);
                } else {
                  errors[name] = fieldValidator; // We have all we need
                }
              }
              if (!(async.length && !IE)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 9;
              return Promise.all(async.map(function (fieldValidator) {
                return fieldValidator();
              })).then(function (results) {
                results.forEach(function (error, i) {
                  errors[asyncNames[i]] = error;
                });
              });
            case 9:
              dispatch(validateFormAction(formId, errors));
            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var serverSideValidation = exports.serverSideValidation = function serverSideValidation(_ref3) {
  var formId = _ref3.formId,
    validationUrl = _ref3.validationUrl,
    requiredStrings = _ref3.requiredStrings,
    requiredDates = _ref3.requiredDates,
    callback = _ref3.callback,
    extraData = _ref3.extraData,
    _ref3$options = _ref3.options,
    options = _ref3$options === undefined ? {} : _ref3$options;
  return function () {
    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var handleFormErrors, formState, values, response, responseData, status;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              handleFormErrors = function handleFormErrors(responseData) {
                // Normalise different API responses
                var errors = responseData.data || responseData.error;
                if (!errors) return;
                dispatch(validateFormAction(formId, Object.assign({}, (0, _formInfo.getErrors)(getState(), formId), (0, _lodash.pick)(errors, [].concat(_toConsumableArray(requiredStrings), _toConsumableArray(requiredDates))))));
              };
              formState = (0, _formInfo.getValues)(getState(), formId);
              values = Object.assign({}, (0, _lodash.pick)(formState, requiredStrings), extraData, (0, _lodash.mapValues)((0, _lodash.pick)(formState, requiredDates), _arrayToIso2.default));
              response = void 0;
              _context3.prev = 4;
              _context3.next = 7;
              return _axios2.default.post(validationUrl, values, options);
            case 7:
              response = _context3.sent;
              _context3.next = 15;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](4);
              responseData = _context3.t0 && _context3.t0.response && _context3.t0.response.data;
              if (responseData && (typeof responseData === 'undefined' ? 'undefined' : _typeof(responseData)) === 'object') {
                handleFormErrors(responseData);
              }
              throw _context3.t0;
            case 15:
              status = response.data && response.data.status;
              if (!(status === 'FAILURE')) {
                _context3.next = 19;
                break;
              }
              handleFormErrors(response.data);
              return _context3.abrupt('return');
            case 19:
              if (!callback) {
                _context3.next = 22;
                break;
              }
              _context3.next = 22;
              return callback((0, _formInfo.getForm)(getState()));
            case 22:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[4, 10]]);
    }));
    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};